
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 20 20","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M10.562 5.803l.437.787.828-.352a3 3 0 014.168 2.594l.026.461.369.28a4.062 4.062 0 01-2.452 7.302H6.063a4.062 4.062 0 01-2.334-7.388l.571-.402-.18-.675a3.5 3.5 0 016.443-2.607zM7.5 3c1.693 0 3.168.935 3.936 2.317a4 4 0 015.558 3.46 5.063 5.063 0 01-3.056 9.099H6.061a5.063 5.063 0 01-2.909-9.207A4.506 4.506 0 017.5 3zm2.244 10.5v-.52H7.908l.86-.94c.12-.124.231-.245.331-.364.1-.12.187-.241.26-.36.075-.121.132-.242.172-.363.04-.121.06-.243.06-.366 0-.223-.049-.415-.147-.578a.955.955 0 00-.424-.376 1.567 1.567 0 00-.678-.133c-.282 0-.524.057-.724.17-.2.113-.354.265-.46.456-.105.19-.158.4-.158.629h.659c0-.143.025-.27.076-.38a.594.594 0 01.227-.262.683.683 0 01.372-.095.6.6 0 01.325.084c.09.054.157.129.202.225a.719.719 0 01.072.328.79.79 0 01-.052.273c-.033.092-.09.196-.173.312a4.86 4.86 0 01-.336.412l-1.295 1.4v.448h2.667zM13 12.614v-.52h-.498v-2.54h-.678l-1.716 2.667.022.393h1.714v.886h.659v-.886H13zm-1.156-2.196l-.063.106-.987 1.57h1.05v-1.676z"}})])
          )
        }
      }
    